// extracted by mini-css-extract-plugin
export var chip = "feature_tags-module--chip--19cNQ";
export var icon = "feature_tags-module--icon--3YIvN";